import React from "react";
import { MessageCircle, Heart, Globe, Moon, Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

export type ArenaType = "vibe_booth" | "dating_arena" | "global_arena" | "after_hours" | "event_arena";

interface ArenaTypeBadgeProps {
  type: ArenaType;
  className?: string;
  size?: "sm" | "md";
}

const ARENA_TYPE_CONFIG: Record<ArenaType, { label: string; icon: React.ReactNode; gradient: string }> = {
  vibe_booth: {
    label: "Vibe Booth",
    icon: <MessageCircle className="w-3 h-3" />,
    gradient: "from-emerald-400 to-teal-500",
  },
  dating_arena: {
    label: "Dating Arena",
    icon: <Heart className="w-3 h-3" />,
    gradient: "from-pink-500 to-rose-500",
  },
  global_arena: {
    label: "Global Arena",
    icon: <Globe className="w-3 h-3" />,
    gradient: "from-blue-500 to-cyan-500",
  },
  after_hours: {
    label: "After Hours",
    icon: <Moon className="w-3 h-3" />,
    gradient: "from-indigo-500 to-purple-600",
  },
  event_arena: {
    label: "Event Arena",
    icon: <Sparkles className="w-3 h-3" />,
    gradient: "from-amber-400 to-orange-500",
  },
};

export const ArenaTypeBadge: React.FC<ArenaTypeBadgeProps> = ({ type, className, size = "md" }) => {
  const config = ARENA_TYPE_CONFIG[type] || ARENA_TYPE_CONFIG.vibe_booth;

  return (
    <div
      className={cn(
        "flex items-center gap-1 rounded-full text-white font-medium",
        size === "sm" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs",
        `bg-gradient-to-r ${config.gradient}`,
        className
      )}
    >
      {size === "md" && config.icon}
      <span>{config.label}</span>
    </div>
  );
};

export const getArenaTypeFromContext = (countryCode?: string | null, cityId?: string | null): ArenaType => {
  if (countryCode || cityId) return "global_arena";
  
  const hour = new Date().getHours();
  if (hour >= 22 || hour < 6) return "after_hours";
  
  return "vibe_booth";
};

export default ArenaTypeBadge;
